module.exports = "/src/views/player/hudevo/phonenew/components/map/map.jpg";